import { jsx as _jsx } from "react/jsx-runtime";
import { PERSIST_LANGUAGE_PREFERENCE_URL } from './constants';
/**
 * Hidden iframe component for cross-domain language preference persistence.
 * Enables sharing language preferences across different Guild Education domains via postMessage.
 */
export const LanguageIframe = () => {
    return (_jsx("iframe", { id: "language-preference-storage", src: PERSIST_LANGUAGE_PREFERENCE_URL, style: { display: 'none' }, title: "Language Preference Storage" }));
};
